import { withStyles, WithStyles } from "@mui/styles";
import { DashboardStyleClasses } from "assets/jss/common-styles";
import { WithSnackbar, withSnackbar } from "components/SnackbarProvider/Snackbar";
import { TopicShortViewModel } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { TopicDashboardKnowledgeDatabase } from "views/Topic/Dashboard/TopicDashboardKnowledgeDatabase";
import { TopicDashboardResults } from "views/Topic/Dashboard/TopicDashboardResults";
import { TabOptions, TopicDashboardTabs } from "views/Topic/Dashboard/TopicDashboardTabs";
import { TopicDashboardTrustAndRetention } from "views/Topic/Dashboard/TopicDashboardTrustAndRetention";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    currentTab: TabOptions;
}

interface IProps {
    topic: TopicShortViewModel;
}

type Props = IProps & WithStyles<typeof DashboardStyleClasses> & WithSnackbar & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class TopicAdminDashboard extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            currentTab: TabOptions.Results,
        };
    }

    ///
    private handleTabSelection = (value: TabOptions) => {
        this.setState({ currentTab: value });
    };

    ///
    public render() {
        const { currentTab } = this.state;

        return (
            <div className={this.props.classes.dashboardLargeContainer}>

                <TopicDashboardTabs {...this.props} currentTab={currentTab} onTabChange={this.handleTabSelection} />

                {
                    currentTab == TabOptions.Results
                        ? <TopicDashboardResults {...this.props} topic={this.props.topic} />
                        : currentTab == TabOptions.TrustAndRetention
                            ? <TopicDashboardTrustAndRetention {...this.props} topic={this.props.topic} />
                            : <TopicDashboardKnowledgeDatabase {...this.props} topic={this.props.topic} />
                }

            </div>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(DashboardStyleClasses)(TopicAdminDashboard)));